import Modal from 'components/UI/Modal';
import React from 'react';
import styled from 'styled-components';
import { AiOutlineFileSync } from 'react-icons/ai';
import PropTypes from 'prop-types';
import AddCircleOutlineIcon from 'components/Icons/AddCircleOutlineIcon';
import PriorTemplateIcon from 'components/Icons/PriorTemplateIcon';

import '../ApplicationForm.scss';

const StyledContainer = styled.div`
  height: 206px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
  flex: 1 1 0;
  border-radius: 4px;
  border: 1px solid #dfe3e4;
  background: #fff;

  &:hover {
    border-color: #215c73;
    cursor: pointer;
    border-radius: 0.25rem;
    border-width: 2px;
  }

  p {
    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    margin-bottom: 0;
    color: black;
  }

  svg {
    width: 45px;
    height: 52px;
    flex-shrink: 0;
    color: #215c73;
  }
`;

const StyledMainContainer = styled.div`
  display: flex;
  gap: 20px;
`;

function ApplicationSelectionModal({ isOpen, onSubmit, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      title="Create Application Form"
      onCancel={onClose}
      onSubmit={onSubmit}
      disableFooter
      className="application-selection-modal"
      headerBorder={true}
    >
      <StyledMainContainer>
        <StyledContainer onClick={e => onSubmit('new')}>
          <AddCircleOutlineIcon fillColor="#215c73" />
          <p>Create From Scratch</p>
        </StyledContainer>

        <StyledContainer onClick={e => onSubmit('template')}>
          <PriorTemplateIcon fillColor="#215c73" />
          <p>Choose a Prior Template</p>
        </StyledContainer>
      </StyledMainContainer>
    </Modal>
  );
}

ApplicationSelectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ApplicationSelectionModal;
